import React, { memo, useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import ManageCustomerAddress from "./ManageCustomerAddressMC";

import DropdownMC from "../../components/DropdownMC";
import { useCustomerAddresses } from "./hooks/useCustomerAddresses";

const CustomerAddressDropdown = ({
  customer
}) => {
  const { t: tCommon } = useTranslation('Common');

  const {
    control,
    getValues,
    setValue,
    reset
  } = useFormContext();

  const {
    dropdownKey, openedCustomerAddress, customerAddressesOptions,
    orderAddressValue, updateAddressOptions, toggleModal, customerWebId
  } = useCustomerAddresses({
    customer,
    getValues,
    setValue,
    useWatch,
    control,
    reset,
    tCommon
  });

  const handleToggleModal = useCallback(() => {
    toggleModal();
  }, [toggleModal]);

  return (
    <div className="tw-w-full">
      <div className="tw-w-full">
        <DropdownMC
          key={dropdownKey}
          id="orderAddress"
          name="orderAddress"
          label={tCommon('form.address')}
          options={customerAddressesOptions}
          defaultValue={orderAddressValue}
          useFloatingLabel
          placeholder="Seleccionar"
        />
      </div>

      {openedCustomerAddress && (
        <ManageCustomerAddress
          customer={customer}
          updateList={updateAddressOptions}
          toggleModal={handleToggleModal}
          fakeAddress={!customerWebId}
          hideNotification
        />
      )}
    </div>
  );
};

export default memo(CustomerAddressDropdown);
